import {
  DescriptionList,
  Spinner,
  Stack,
  Button,
  IconButton
} from '@efast_public/fjd-component-library';
import {
  NachrichtType,
  NachrichtModel
} from '../../../../../api/models/Nachrichten/NachrichtModel';
import _moment from 'moment';
import { ContentTab } from '../../../SchreibtischPage';
import {
  AttachmentModel,
  CaseDetailsModel
} from '../../../../../api/models/Case/CaseDetailsModel';
import NachrichtBody from './NachrichtBody';
import BescheidstatusBadge from '../../../../shared/BescheidstatusBadge/BescheidstatusBadge';
import { Bescheidstatus } from '../../../../../api/models/Status/Bescheidstatus';
import AntragBadge from '../../../../shared/AntragBadge/AntragBadge';
import saveAs from 'file-saver';
import { useAttachmentDownloadGet } from '../../../../../api/hooks/useAttachmentDownload';
import {
  openBlobInNewTab,
  PDF_MIME_TYPE
} from '../../../../../shared/utils/fileUtils';
import React from 'react';

interface NachrichtProps {
  readonly nachricht: NachrichtModel;
  readonly setContentTabState: (val: ContentTab) => void;
  readonly antragssteller: string | undefined;
  readonly bescheidstatus?: Bescheidstatus;
  readonly caseDetails: CaseDetailsModel;
}

function NachrichtContent({ caseDetails, ...props }: NachrichtProps) {
  const { downloadAttachment } = useAttachmentDownloadGet();

  const changeToDetailsTab = (): void => {
    document.getElementById('antragsdetails-tabs-tab0')?.click();
  };

  const initialSubmissionId: string =
    caseDetails.initialSubmission.submissionId;

  const isPostalischBeschieden = (nachrichtType: NachrichtType): boolean => {
    return nachrichtType === NachrichtType.BESCHEID_POSTALISCH;
  };

  if (props.nachricht) {
    return (
      <Stack direction={'column'}>
        <DescriptionList>
          <DescriptionList.Item
            key={'createdOn'}
            description={_moment
              .utc(props.nachricht.createdOn)
              .local()
              .format('DD.MM.YYYY • HH:mm')}
            title={
              props.nachricht.isBescheid &&
              isPostalischBeschieden(props.nachricht.nachrichtType)
                ? 'Beschieden am'
                : 'Gesendet am'
            }
          />
          {props.nachricht.isVonBehoerde ? (
            <>
              <hr className="fjd2-description-list_divider" />
              <DescriptionList.Item
                key={'absenderName'}
                description={props.nachricht.absenderName}
                title={'Absender:in'}
              />
            </>
          ) : (
            <React.Fragment />
          )}
          {!props.nachricht.isVonBehoerde &&
          !(
            props.nachricht.isBescheid &&
            isPostalischBeschieden(props.nachricht.nachrichtType)
          ) ? (
            <>
              {' '}
              <hr className="fjd2-description-list_divider" />
              <DescriptionList.Item
                key={'empfaenger'}
                description={
                  props.nachricht.isVonBehoerde
                    ? props.antragssteller
                    : props.nachricht.organisationUnitName
                }
                title={'Empfänger:in'}
              />
            </>
          ) : (
            <React.Fragment />
          )}
          {!(
            props.nachricht.isBescheid &&
            isPostalischBeschieden(props.nachricht.nachrichtType)
          ) ? (
            <>
              <hr className="fjd2-description-list_divider" />
              <DescriptionList.Item
                key={'betreff'}
                description={props.nachricht.betreff}
                title={'Betreff'}
              />
            </>
          ) : (
            <React.Fragment />
          )}
          {props.nachricht.hasAttachments ? (
            <>
              <hr className="fjd2-description-list_divider" />

              <DescriptionList.Item
                key={'attachments'}
                description={
                  <>
                    <Stack direction="row" spacing="xs">
                      <Stack
                        direction="column"
                        key={'fileNamesStack'}
                        id={'fileNamesStack'}
                      >
                        {props.nachricht.attachment.map(
                          (attachment: AttachmentModel) => (
                            <div
                              key={`fileNamesStack_${attachment.id}`}
                              id={`fileNamesStack_${attachment.id}`}
                            >
                              <Stack
                                direction={'row'}
                                spacing="xs"
                                alignItems="center"
                              >
                                <Button
                                  variant="primary-text"
                                  size="sm"
                                  onClick={() => {
                                    if (
                                      attachment.mimeType === 'application/pdf'
                                    ) {
                                      downloadAttachment(
                                        caseDetails.caseId,
                                        props.nachricht?.submissionId,
                                        attachment?.id
                                      ).then((file) => {
                                        openBlobInNewTab(
                                          new File(
                                            [file.data],
                                            attachment.description +
                                              attachment.filetype,
                                            {
                                              type: PDF_MIME_TYPE
                                            }
                                          )
                                        );
                                      });
                                    }
                                  }}
                                >
                                  {attachment.description + attachment.filetype}
                                </Button>
                                {attachment.isBescheid &&
                                  props.bescheidstatus && (
                                    <BescheidstatusBadge
                                      bescheidstatus={props.bescheidstatus}
                                      fjdBadgeSize={'xs'}
                                      badgeLabel={'Bescheid'}
                                    />
                                  )}
                                {props.nachricht.submissionId ===
                                  initialSubmissionId && (
                                  <AntragBadge data-testid="antragBadge-Nachricht" />
                                )}
                                {attachment.mimeType === 'application/pdf' ? (
                                  <div
                                    key={`previewsAndDownloadsStack_view_${attachment.id}`}
                                    id={`previewsAndDownloadsStack_view_${attachment.id}`}
                                  >
                                    <IconButton
                                      variant="primary-text"
                                      icon="view"
                                      label={'Dokument anzeigen'}
                                      size="sm"
                                      onClick={() => {
                                        if (
                                          attachment.mimeType ===
                                          'application/pdf'
                                        ) {
                                          downloadAttachment(
                                            caseDetails.caseId,
                                            props.nachricht?.submissionId,
                                            attachment?.id
                                          ).then((file) => {
                                            openBlobInNewTab(
                                              new File(
                                                [file.data],
                                                attachment.description +
                                                  attachment.filetype,
                                                {
                                                  type: PDF_MIME_TYPE
                                                }
                                              )
                                            );
                                          });
                                        }
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <div
                                    key={`previewsAndDownloadsStack_view_${attachment.id}`}
                                    id={`previewsAndDownloadsStack_view_${attachment.id}`}
                                  ></div>
                                )}
                                <div
                                  key={`previewsAndDownloadsStack_download_${attachment.id}`}
                                  id={`previewsAndDownloadsStack_download_${attachment.id}`}
                                >
                                  <IconButton
                                    variant="primary-text"
                                    icon="download"
                                    label={'Dokument herunterladen'}
                                    size="sm"
                                    onClick={() => {
                                      downloadAttachment(
                                        caseDetails.caseId,
                                        props.nachricht?.submissionId,
                                        attachment?.id
                                      ).then((file) => {
                                        saveAs(
                                          file.data as Blob,
                                          attachment.description +
                                            attachment.filetype,
                                          { autoBom: false }
                                        );
                                      });
                                    }}
                                  />
                                </div>
                              </Stack>
                            </div>
                          )
                        )}
                      </Stack>
                    </Stack>
                    <Button
                      variant="primary-text"
                      beforeIcon="launch"
                      size="sm"
                      onClick={() => {
                        document
                          .getElementById('antragsdetails-tabs-tab1')
                          ?.click();
                      }}
                    >
                      zu allen Dokumenten
                    </Button>
                  </>
                }
                title={'Anlagen'}
              />
            </>
          ) : (
            <React.Fragment />
          )}
          <hr className="fjd2-description-list_divider" />
        </DescriptionList>
        <NachrichtBody
          onLinkClicked={changeToDetailsTab}
          nachricht={props.nachricht}
        />
      </Stack>
    );
  } else {
    return <Spinner />;
  }
}

export default NachrichtContent;
